


















































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import store from '@/store'
import Setting from '@/store/modules/Setting'
import SettingService from '@/services/SettingService'
import { EhumbNailsDisplay } from '@/models/Setting/Enum'
//@ts-ignore
import _ from 'lodash'
const SettingModule = getModule(Setting, store)

enum DISPLAY_CALENDAR_ON_TOP_OPTIONS {
  HIDDEN,
  DISPLAY
}

@Component
export default class SettingDisplay extends Vue {
  private confirmChange: any
  private display_items_options: any[] = [
    { id: 1, value: 5 },
    { id: 2, value: 10 },
    { id: 3, value: 20 },
    { id: 4, value: 30 },
    { id: 5, value: 50 },
    { id: 6, value: 100 }
  ]
  private display_items_comment_options: any[] = [
    { id: 1, value: 10 },
    { id: 2, value: 20 },
    { id: 3, value: 30 },
    { id: 4, value: 50 },
    { id: 5, value: 100 }
  ]
  private display_thumbnails_options: any[] = [
    {
      id: 1,
      value: EhumbNailsDisplay.HIDE_THUMBNAILS,
      text: this.$t('setting.setting_display.no_display')
    },
    {
      id: 2,
      value: EhumbNailsDisplay.DISPLAY_THUMBNAILS,
      text: this.$t('setting.setting_display.display')
    }
  ]
  private days_of_week: any[] = [
    {
      id: 1,
      value: 1,
      text: this.$t('setting.setting_display.monday')
    },
    {
      id: 2,
      value: 2,
      text: this.$t('setting.setting_display.tuesday')
    },
    {
      id: 3,
      value: 3,

      text: this.$t('setting.setting_display.wednesday')
    },
    {
      id: 4,
      value: 4,
      text: this.$t('setting.setting_display.thursday')
    },
    {
      id: 5,
      value: 5,
      text: this.$t('setting.setting_display.friday')
    },
    {
      id: 6,
      value: 6,
      text: this.$t('setting.setting_display.saturday')
    },
    {
      id: 7,
      value: 0,
      text: this.$t('setting.setting_display.sunday')
    }
  ]
  private setting_display: any = {
    number_item_lists: '',
    number_items_list_comment: '',
    display_image_video: '',
    first_day_of_week: '',
    display_calendar_on_top: DISPLAY_CALENDAR_ON_TOP_OPTIONS.HIDDEN // not allow display
  }

  private display_calendar_on_top_options = [
    {
      id: 1,
      value: DISPLAY_CALENDAR_ON_TOP_OPTIONS.HIDDEN,
      text: this.$t('setting.setting_display.non_display')
    },
    {
      id: 2,
      value: DISPLAY_CALENDAR_ON_TOP_OPTIONS.DISPLAY,
      text: this.$t('setting.setting_display.allow_display')
    },
  ]

  created() {
    this.getSettingDisplay()
  }

  private normalizeSettingDisplay(settingDisplay: any) {
    return {
      number_item_lists: Number(settingDisplay?.number_item_lists ?? 10),
      number_items_list_comment: Number(
        settingDisplay?.number_items_list_comment ?? 10
      ),
      display_image_video: Number(
        settingDisplay?.display_image_video ??
          EhumbNailsDisplay.DISPLAY_THUMBNAILS
      ),
      first_day_of_week: Number(settingDisplay?.first_day_of_week ?? 1),
      display_calendar_on_top: Number(
        settingDisplay?.display_calendar_on_top ??
          DISPLAY_CALENDAR_ON_TOP_OPTIONS.HIDDEN
      )
    }
  }

  beforeRouteLeave(to: any, from: any, next: any) {
    //this case for modal search header
    if (document.querySelectorAll('#modal-search-header').length) {
      next()

      //normal case
    } else if (
      _.isEqual(
        this.normalizeSettingDisplay(this.setting_display),
        this.normalizeSettingDisplay(store.state.setting.setting.setting_display)
      )
    ) {
      next()
    } else {
      this.confirmChange = next
      this.$bvModal.show('modal-confirm')
    }
  }

  confirm() {
    this.confirmChange()
  }

  getSettingDisplay() {
    this.setting_display = this.normalizeSettingDisplay(
      store.state.setting.setting.setting_display
    )
  }

  changeDisplay() {
    let setting_data = { ...store.state.setting.setting}
    setting_data.setting_display = this.setting_display
    SettingService.updateUserSetting(setting_data)
      .then(response => {
        if (response.status === 200) {
          let setting_display = response.data.setting_display
          SettingModule.CHANGE_DISPLAY(setting_display)
          this.$bvModal.show('modal-success')
        }
      })
      .catch(error => {
        this.getSettingDisplay()
        this.$bvModal.show('modal-error')
      })
  }
}
